import { render, staticRenderFns } from "./UserLogs.vue?vue&type=template&id=dbcae4f6&scoped=true"
import script from "./UserLogs.vue?vue&type=script&lang=js"
export * from "./UserLogs.vue?vue&type=script&lang=js"
import style0 from "./UserLogs.vue?vue&type=style&index=0&id=dbcae4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcae4f6",
  null
  
)

export default component.exports